import type { ListingDesignItem } from '../../domain/models/ProductListing';
import { parsePrice } from '@/shared/utils/priceFormatter';

export const LISTING_PAGE_PRODUCT_VIEWED_EVENT_ID = 'listing_page_product_viewed';

export interface ListingPageProductViewedParams {
  product: ListingDesignItem;
  scrollDepth: number;
  horizontalPosition: number;
}

/**
 * Build eventLogger payload for `listing_page_product_viewed`.
 * Matches old-react productListingV1 `handleProductItemVisibility`.
 */
export function buildListingPageProductViewedPayload({
  product,
  scrollDepth,
  horizontalPosition,
}: ListingPageProductViewedParams): Record<string, string | number> {
  return {
    _eventId: LISTING_PAGE_PRODUCT_VIEWED_EVENT_ID,
    product_id: String(product.designId),
    product_name: product.designName || '',
    category_name: product.categoryType || '',
    mrp: parsePrice(product.price),
    selling_price: parsePrice(product.discountedPrice ?? product.price),
    discount_price: parsePrice(product.discountValue),
    discount_percent: product.discountPercent != null ? Number(product.discountPercent) : 0,
    currency: 'INR',
    scroll_depth: scrollDepth,
    horizontal_position: horizontalPosition,
    offer_name: product.discountName || '',
  };
}
